<template>
  <div style="width:100%;height:auto;">
    <div class="body-main" style="">
      <el-form
        label-width="150px"
        style="width:800px"
        ref="dataFormRef"
        :model="data_info"
        :rules="rules"
      >
        <el-form-item label="开户银行卡照片：" prop="">
          <uploadImg
            class="uploadImg"
            :imgTitle="'bank'"
            @getReturn="getReturn"
            @removeImg="removeImg"
          >
            <template slot="centerName">
              银行卡
            </template>
          </uploadImg>
        </el-form-item>
        <el-form-item label="开户银行卡号：" prop="account_number"
          ><el-input v-model="data_info.account_number"></el-input>
        </el-form-item>
        <el-form-item label="店铺号：" prop="mch_no">
          <el-input v-model="data_info.mch_no"></el-input>
        </el-form-item>
        <el-form-item label="账户名：" prop="account_name">
          <el-input v-model="data_info.account_name"></el-input>
        </el-form-item>
        <el-form-item label="账户类型：" prop="account_type">
          <el-select
            v-model="data_info.account_type"
            placeholder="选择账户类型"
          >
            <el-option
              key="ACCOUNT_TYPE_BUSINESS"
              label="对公银行账户"
              value="ACCOUNT_TYPE_BUSINESS"
            >
            </el-option>
            <el-option
              key="ACCOUNT_TYPE_PRIVATE"
              label="对私法人"
              value="ACCOUNT_TYPE_PRIVATE"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="银行名称：" prop="account_bank">
          <el-select
            v-model="data_info.account_bank"
            filterable
            placeholder="开户银行名称，若列表中没有则选择其他银行"
          >
            <el-option
              v-for="item in bank_name_options"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开户行省市区：" prop="bank_address_code">
          <el-cascader
            placeholder="选择开户行省市区"
            v-model="data_info.bank_address_code"
            class="qualification-type-select"
            :options="provincearr"
            @change="shophandleChange"
            :filterable="true"
            :clearable="true"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          label="银行(含支行)名称："
          style="width:100%"
          prop="bank_name"
        >
          <el-row>
            <el-col :span="3">
              <div id="bank_select">
                <el-select
                  v-model="bank_province"
                  filterable
                  placeholder="选择省"
                  @change="getCity"
                >
                  <el-option
                    v-for="item in province_option"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="3">
              <div id="bank_select" style="margin-left:100px">
                <el-select
                  v-model="bank_city"
                  filterable
                  placeholder="选择市"
                  style="width:200px"
                  @change="getOpenBank"
                >
                  <el-option
                    v-for="item in city_option"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6" style="margin-left:200px;">
              <div id="bank_name_select">
                <el-select
                  v-model="data_info.bank_name"
                  filterable
                  placeholder="选择开户行支行（可模糊查询）"
                  style="width:200px; !important"
                  @change="getOpenBnakName"
                >
                  <el-option
                    v-for="item in open_bank_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button @click="submit" type="primary" plain>
            保存修改
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import {
  GetBankProvince,
  GetBankcity,
  GetBankCode,
  ModifySettlementAccount
} from "@/api/index";
import uploadImg from "@/components/uploadImg.vue";
import { province, map } from "@/js/map";
export default {
  name: "changeBank",
  components: { uploadImg },
  data() {
    return {
      provincearr: [],
      map: [],
      img_bank_card: "",
      bank_name_options: [
        { value: "1", label: "中国农业发展银行" },
        { value: "2", label: "其他银行" },
        { value: "3", label: "广发银行" },
        { value: "4", label: "村镇银行" },
        { value: "5", label: "上海浦东发展银行" },
        { value: "6", label: "中国农业银行" },
        { value: "7", label: "渤海银行" },
        { value: "8", label: "中国工商银行" },
        { value: "9", label: "中国银行" },
        { value: "10", label: "华夏银行" },
        { value: "11", label: "中国民生银行" },
        { value: "12", label: "平安银行" },
        { value: "13", label: "中国人民银行" },
        { value: "14", label: "交通银行" },
        { value: "15", label: "中国建设银行" },
        { value: "16", label: "招商银行" },
        { value: "17", label: "城市商业银行" },
        { value: "18", label: "中国邮政储蓄银行" },
        { value: "19", label: "中信银行" },
        { value: "20", label: "农村商业银行" },
        { value: "21", label: "兴业银行" },
        { value: "22", label: "中国光大银行" },
        { value: "23", label: "浙商银行" }
      ],
      province_option: [],
      city_option: [],
      open_bank_options: [],
      bank_province: "", //省
      bank_city: "",
      data_info: {
        mch_no: "",
        account_number: "", //银行卡号
        account_type: "", //账户类型
        account_name: "", //账户名
        account_bank: "", //银行卡
        bank_address_code: "", //
        bank_name: ""
      },
      rules: {
        mch_no: [{ required: true, message: "请输入店铺号", trigger: "blur" }],
        account_number: [
          { required: true, message: "请输入银行卡号", trigger: "blur" }
        ],
        account_type: [
          { required: true, message: "请选择账户类型", trigger: "blur" }
        ],
        account_name: [
          { required: true, message: "请输入账户名", trigger: "blur" }
        ],
        account_bank: [
          { required: true, message: "请选择开户银行", trigger: "blur" }
        ],
        bank_address_code: [
          { required: true, message: "请选择开户银行省市", trigger: "blur" }
        ],
        bank_name: [
          {
            required: true,
            message: "请选择开户银行（含支行）名称",
            trigger: "blur"
          }
        ]
      }
    };
  },
  async mounted() {
    this.provincearr = province;
    this.map = map;

    try {
      var { data: res } = await GetBankProvince();
      for (var i = 0; i < res.resp_data.length; i++) {
        this.province_option.push({
          label: res.resp_data[i],
          value: i
        });
      }
    }catch(e){
      console.log(e);
    }
  },
  methods: {
    async getCity() {
      this.city_option = [];
      var { data: res } = await GetBankcity(this.bank_province);
      for (var i = 0; i < res.resp_data.length; i++) {
        this.city_option.push({
          label: res.resp_data[i],
          value: i
        });
      }
    },
    async getOpenBank() {
      var data = {
        province: this.bank_province,
        city: this.bank_city
      };
      var { data: res } = await GetBankCode(JSON.stringify(data));
      if (res.resp_data.length > 0) {
        var arr = res.resp_data;
        this.open_bank_options = [];
        if (this.data_info.account_bank == "其他银行") {
          for (var i = 0; i < arr.length; i++) {
            this.open_bank_options.push({
              label: arr[i].full_name,
              value: arr[i].bank_code
            });
          }
        } else {
          for (var x in arr) {
            if (arr[x].full_name.indexOf(this.data_info.account_bank) >= 0) {
              this.open_bank_options.push({
                label: arr[x].full_name,
                value: arr[x].bank_code
              });
            }
          }
        }
      }
    },
    getOpenBnakName() {
      return;
    },
    async shophandleChange(e) {
      if (e.length == 0) {
        return;
      }
      this.data_info.bank_address_code = e[2];
    },
    getReturn(res) {
      if (res.img_info) {
        this.data_info.account_number = res.img_info.number;
      }
    },
    removeImg(res) {
      if (res) {
        this.data_info.account_number = "";
      }
    },
    submit() {
      this.$refs.dataFormRef.validate(async valid => {
        // console.log(JSON.stringify(data_info))
        if (valid) {
          var { data: res } = await ModifySettlementAccount(
            JSON.stringify(this.data_info)
          );
          console.log(this.data_info);
          console.log(res);
          if (res.return_code == "FAIL" || res.return_msg) {
            this.$message(res.return_msg);
            return;
          }
          if (res.result_code == "FAIL" || res.result_msg) {
            this.$message(res.result_msg);
            return;
          }
          if (
            res.return_code == "SUCCESS" &&
            res.result_code == "SUCCESS" &&
            res.resp_data.length > 0
          ) {
            this.warnMessage(res.resp_data);
            return;
          }
          if (
            res.return_code == "SUCCESS" &&
            res.result_code == "SUCCESS" &&
            res.resp_data.length == 0
          ) {
            this.successMessage("修改成功");
          }
        } else {
          return;
        }
      });
    }
  }
};
</script>
<style scoped>
.el-form-item >>> .el-input {
  width: 400px !important;
}
.el-form-item {
  margin-bottom: 10px;
}
#bank_select >>> .el-input {
  width: 150px !important;
}
#bank_name_select >>> .el-input {
  width: 250px !important;
}
.body-main {
  /* position: absolute;
  left: 50%;
  top: 50%; */
  width: 800px;
  height: 90%;
  /* transform: translate(-50%, -50%); */
}
</style>
